import { DateTime } from 'luxon';
import Pikaday from 'pikaday';



/**
***  pikaday.config
***  @params id element
*/
window.pikaday = ( $elm, $day = 0 ) => {

  const minDate = daysLater($day);

  new Pikaday({
    field: $elm,
    format: 'YYYY-M-D',
    showMonthAfterYear: true,
    toString(date, format) {
      return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
    },
    minDate: new Date(minDate),
    i18n: {
      previousMonth : '前月',
      nextMonth     : '次月',
      months        : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
      weekdays      : ['日曜日','月曜日','火曜日','水曜日','木曜日','金曜日','土曜日'],
      weekdaysShort : ['日','月','火','水','木','金','土']
    },
    yearSuffix: '年',
    disableDayFn: function(date) {
      // 日曜日を除外
      if( date.getDay() === 0 ){
        return true
      }

      // 指定した日付を除外
      const chkDate = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');

      // 祝日を除外
      if( holidaysArr.includes(chkDate) ){
        return true
      }
    }
  }); // end of Pikaday

  // 日後
  function daysLater(day){
    let dt = new Date();
    dt.setDate( dt.getDate() + day );
    // 日曜日なら1日足す
    if( dt.getDay() === 0 ){
      dt.setDate( dt.getDate() + 1 );
    }
    return dt.getFullYear() + '-' + ( '00' + (dt.getMonth() + 1) ).slice(-2) + '-' + ( '00' + dt.getDate()).slice(-2);
  }
}

// 祝日データを取得する
//
global.holidaysArr = [];
// 取得したい JSON がある URL を変数へ代入
let requestURL = 'https://holidays-jp.github.io/api/v1/date.json';
// HTTP リクエストを作成するのに、new を使って XMLHttpRequest から新しいリクエストオブジェクトをつくる
let request = new XMLHttpRequest();
// 新しいリクエストを開始
request.open('GET', requestURL);
// XHR オブジェクトがサーバーから返されるデータを判断
request.responseType = 'json';
// リクエストを送信
request.send();
// リクエストに対するレスポンス (response プロパティから取得できます) を 変数へ代入
request.onload = function(){
  const holidays = request.response;
  Object.keys(holidays).forEach( function(elm){
    holidaysArr.push(elm);
  });
}
